const ObservationActionSuggestion = () => {
  return <div>ObservationActionSuggestion</div>;
};

export default ObservationActionSuggestion;
